// Central mapping for connection type labels. Backward compatible with the old ids ("love").
export const CONNECTION_LABELS = {
  dating: "Dating",
  love: "Dating",              // legacy id from earlier profiles
  friendship: "Friendship",
  matchday: "Matchday companion",
  fivesaside: "Five-a-side",
  prematch: "Pre-match pub",
  away: "Away travel buddy",
};

export const labelForConnection = (id) => CONNECTION_LABELS[id] || (id?.[0]?.toUpperCase() + id?.slice(1)) || id;
